import FooterPersonalPrice from "./footer/footercomponent";

const FooterPricing = () => {
  return (
    <>
      <FooterPersonalPrice />
    </>
  );
};

export default FooterPricing;
